/**
 * Product tile hover image.
 *
 * `snippets/product-tile.liquid` renders the second product image (the
 * `.not-first` layer shown on hover) through `responsive-image` with
 * `lazy: true`, so it only has a 1x1 placeholder and a `data-src` with a
 * `{width}` token. lazysizes does not load it on its own because the layer
 * sits at opacity 0, and `assets/custom.css` hides it on devices without
 * hover. This script loads it the first time a pointer enters the tile, at the
 * tile's own width (capped at 2x pixel density), so collection pages do not
 * download a second image per product up front.
 */
(function () {
  if (window.__skuTileHoverImage) return;
  window.__skuTileHoverImage = true;

  if (!window.matchMedia('(hover: hover)').matches) return;

  function pickWidth(img, tileWidth) {
    var widths;
    try {
      widths = JSON.parse(img.getAttribute('data-widths') || '[]');
    } catch (error) {
      widths = [];
    }
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var target = Math.ceil(tileWidth * dpr);
    for (var i = 0; i < widths.length; i++) {
      if (widths[i] >= target) return widths[i];
    }
    return widths.length ? widths[widths.length - 1] : target;
  }

  function load(tile) {
    var img = tile.querySelector('.not-first img[data-src]');
    if (!img || img.getAttribute('data-hover-loaded')) return;
    img.setAttribute('data-hover-loaded', 'true');

    var width = pickWidth(img, tile.offsetWidth || 400);
    img.src = img.getAttribute('data-src').replace('{width}', width);
    // Keep lazysizes from processing it a second time.
    img.classList.remove('lazyload');
    img.classList.add('lazyloaded');
  }

  document.addEventListener(
    'pointerenter',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var tile = target.closest('.product-tile__images');
      if (tile) load(tile);
    },
    true
  );
})();
